import React from 'react';
export function Footer() {
  return <footer className="bg-white py-5 border-t border-gray-100" data-id="element-40">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-41">
        <div className="text-gray-500 text-sm" data-id="element-42">
          © {new Date().getFullYear()} The Quiet Cabin. All rights reserved.
        </div>
        <div className="flex gap-6 text-sm text-gray-400" data-id="element-43">
          <a href="#" className="hover:text-brand-blue transition-colors" data-id="element-44">
            Terms
          </a>
          <a href="#" className="hover:text-brand-blue transition-colors" data-id="element-45">
            Privacy
          </a>
          <a href="#" className="hover:text-brand-blue transition-colors" data-id="element-46">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}